import "./src/assets/css/index.css"
require("./src/assets/css/code.css")
